import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const EVENTS = [
  { title: "Weddings", desc: "Give your guests the elegance they deserve on your most important day." },
  { title: "Concerts", desc: "Upscale restrooms that keep guests comfortable between sets." },
  { title: "Festivals", desc: "Clean, dignified restrooms for multi-day outdoor festivals." },
  { title: "City Events", desc: "Community-friendly luxury for public gatherings." },
  { title: "Corporate Events", desc: "Impress executives, clients, and VIP guests alike." },
  { title: "Private Parties", desc: "Discreet, upscale service for private residences." },
  { title: "Film Productions", desc: "On-set comfort for cast and crew, on location." },
  { title: "Sporting Events", desc: "Elevated facilities for tournaments and races." },
  { title: "Community Events", desc: "Charity galas, fundraisers, and civic celebrations." },
  { title: "Multi-Day Events", desc: "Extended servicing available for continuous comfort." },
];

export default function Events() {
  return (
    <div>
      <section className="section">
        <div className="mx-auto max-w-6xl">
          <div className="overline">Events We Serve</div>
          <h1 className="h-display mt-3 text-5xl md:text-6xl leading-[1.05]">Every guest, every event, elevated.</h1>
          <p className="mt-6 text-graphite max-w-2xl text-lg leading-relaxed">
            Whether you're planning an intimate wedding or a multi-day festival, our luxury trailers bring quiet elegance to any location.
          </p>
        </div>
      </section>

      <section className="pb-24 px-6 md:px-10 lg:px-16">
        <div className="mx-auto max-w-6xl grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {EVENTS.map((e) => (
            <Link key={e.title} to="/booking" data-testid={`event-card-${e.title.toLowerCase().replace(/ /g,'-')}`} className="card-soft p-8 group flex flex-col">
              <div className="overline">Elevated for</div>
              <h3 className="h-display text-2xl mt-2">{e.title}</h3>
              <p className="text-graphite text-sm mt-3 flex-1 leading-relaxed">{e.desc}</p>
              <div className="mt-6 inline-flex items-center gap-2 text-sm text-charcoal opacity-60 group-hover:opacity-100 transition-opacity">
                Request a booking <ArrowRight className="h-4 w-4" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
